import { render, staticRenderFns } from "./expert.vue?vue&type=template&id=dcf3443a&scoped=true&"
import script from "./expert.vue?vue&type=script&lang=js&"
export * from "./expert.vue?vue&type=script&lang=js&"
import style0 from "./expert.vue?vue&type=style&index=0&lang=css&"
import style1 from "./expert.vue?vue&type=style&index=1&id=dcf3443a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf3443a",
  null
  
)

export default component.exports